import { GridInputs } from "../../../../../components/Functional";

const getCollectionInputs = ({ artists, focuses } = {}) => ({
  className: "grid grid-rows-2 gap-4",
  inputs: [
    {
      className: "grid grid-cols-1 gap-4 lg:grid-cols-4",
      inputs: [
        {
          hasOperator: true,
          isMulti: true,
          label: "Artist",
          name: "_contactArtist.artistId",
          options: artists?.map(artist => ({
            label: artist.name,
            value: artist.id,
          })),
          type: "multi-select",
        },
        {
          hasOperator: true,
          isMulti: true,
          label: "Focus",
          name: "_contactFocus.focusId",
          options: focuses?.map(focus => ({
            label: focus.description,
            value: focus.id,
          })),
          type: "multi-select",
        },
      ],
    },
    {
      className: "grid grid-cols-1 gap-4 lg:grid-cols-4",
      inputs: [
        { label: "Collection Notes", name: "collection", type: "text" },
        {
          label: "Collection Status",
          name: "collectionActive",
          options: [
            { label: "All", value: null },
            { label: "Active", value: -1 },
            { label: "Inactive", value: 0 },
          ],
          type: "select",
        },
      ],
    },
  ],
});

const Collection = props => {
  const { artists, focuses, formik } = props || {};

  const inputs = getCollectionInputs({ artists, focuses });

  return <GridInputs formik={formik} {...inputs} />;
};

export default Collection;
export { getCollectionInputs };
